import styled from "vue-styled-components";

export const CSectionFlavors = styled.section`
    &#flavors {
        padding-top: 3rem;
        .flavors {
            display: flex;
            flex-direction: column;
            gap: 1rem;
            &__item {
                display: flex;
                align-items: center;
                gap: 1rem;
                line-height: 160%;

                &--active {
                    box-shadow: -1px 3px 8px rgba(0, 0, 0, 0.05);
                }

                &--disabled {
                    opacity: 0.7;
                    cursor: not-allowed;
                    .flavor__select,
                    .flavor__description {
                        pointer-events: none;
                    }
                }

                .photo {
                    width: 10.7rem;
                    min-width: 10.7rem;
                    height: 10.7rem;
                    margin: 0;
                    &__img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }
                }

                .flavor {
                    width: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    gap: 3rem;
                    padding: 0.7rem 1rem 0.7rem 0;
                    &__name,
                    &__description,
                    &__price {
                        margin: 0;
                        font-size: 1.5rem;
                    }
                    &__name + .flavor__description,
                    &__price {
                        margin-top: 0.6rem;
                        font-size: 1.4rem;
                    }
                    &__name {
                        color: ${props => props.theme?.products?.product_page?.color_title ?? '#21293c'};
                    }
                    &__price {
                        color: ${props => props.theme?.products?.product_page?.price_color ?? '#595959'};
                        font-weight: ${props => props.theme?.products?.product_page?.font_weight_price ?? 700};
                    }
                    &__description {
                        color: ${props => props.theme?.text_site_color ?? '#4a505e'};
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        line-clamp: 2;
                        -webkit-box-orient: vertical;
                    }

                    &__select {
                        height: 35px;
                        width: 35px;
                        min-width: 35px;
                        background: #fff;
                        border-radius: 50%;
                        box-shadow: 0 12px 30px rgba(0, 0, 0, 0.15);
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        cursor: pointer;
                        i {
                            font-size: 1.6rem;
                            color: #dadada;
                        }
                        &--active {
                            i {
                                color: ${props => props.theme?.primary_color};
                            }
                        }
                    }
                }
            }
        }
    }

    @media (max-width: 500px) {
        &#flavors {
            .flavors {
                &__item {
                    .photo {
                        width: 7.5rem;
                        min-width: 7.5rem;
                        height: 10.7rem;
                    }
                    .flavor {
                        gap: 1.5rem;
                        padding: 0 1rem 0 0;
                    }
                }
            }
        }
    }
`

export const CRowTieSale = styled.div`
    a, a:hover {
        text-decoration: none;
    }

    .subtitle {
        color: ${props => props.theme?.titles_site_color ?? '#2b2b2d'};
        display: block;
        font: 400 1.8rem/1.1 ${props => props.theme?.font_family ?? 'Open Sans'}, sans-serif;
        margin: 0 0 3.3rem;
        position: relative;
        text-transform: uppercase;
        &:after {
            background-color: ${props => props.theme?.secondary_color};
            bottom: -.9rem;
            content: '';
            display: block;
            height: .2rem;
            left: 0;
            position: absolute;
            width: 1.1rem;
        }
    }

    .banner {
        display: block;
        position: relative;
        background: transparent;
        &.banner-image {
            > a {
                position: relative;
                display: flex;
                justify-content: center;
                align-items: center;
                &:after {
                    display: block;
                    position: absolute;
                    top: 0;
                    right: 0;
                    bottom: 0;
                    left: 0;
                    transition: all .3s ease;
                    /* background: rgba(0, 0, 0, 0.1); */
                    content: '';
                    opacity: 0;
                    visibility: hidden;
                }
                &:hover,
                &:focus {
                    &:after {
                        opacity: 1;
                        visibility: visible;
                    }
                }
                img {
                    display: block;
                    width: 130px;
                    max-width: none;
                    height: auto;
                }
            }
        }
        .banner-sizes {
            display: flex;
            justify-content: center;
            flex-wrap: wrap;
            gap: 0.5rem;
            margin-top: 1rem;
            margin-bottom: 0;
            .sizes {
                display: flex;
                margin: 0;
                li {
                    padding: 1px 5px;
                    margin: 0;
                    cursor: pointer;
                    transition: all .2s linear;
                    color: ${props => props.theme?.products?.grid?.size?.color ?? '#000'};
                    border-radius: ${props => props.theme?.products?.grid?.size?.border_radius ?? '0'};
                    background: ${props => props.theme?.products?.grid?.size?.background_color ?? '#fff'};
                    border: 1px solid ${props => props.theme?.products?.grid?.size?.border_color ?? '#dfdfdf'};
                    &.active-size,
                    &:hover {
                        color: ${props => props.theme?.products?.grid?.size?.color_active ?? '#000'};
                        background: ${props => props.theme?.products?.grid?.size?.background_color_active ?? '#fff'};
                        border: 1px solid ${props => props.theme?.products?.grid?.size?.border_color_active ?? '#000'};
                    }
                    &.active-size {
                        pointer-events: none;
                    }
                    &.disabled-item {
                        opacity: 0.7;
                        pointer-events: none;
                        border: 1px solid red;
                    }
                }
            }
        }
        .banner-colors {
            display: flex;
            justify-content: center;
            flex-wrap: wrap;
            gap: 0.5rem;
            margin-bottom: 0;
            margin-top: 1rem;
            li {
                margin: 0;
                border-radius: 50%;
                border: 1px solid #dfdfdf;
                cursor: pointer;
                span {
                    width: 20px;
                    height: 20px;
                    border-radius: 50%;
                    display: flex;
                    overflow: hidden;
                    .cod-hexa-1 {
                        margin-left: 0px;
                        margin-top: -4px;
                    }
                    .cod-hexa-2 {
                        margin-top: 2px;
                        margin-left: -3px;
                    }
                    .cod-hexa-1,
                    .cod-hexa-2 {
                        width: 20px;
                        height: 22px;
                        transform: rotate(30deg);
                    }
                }
                &.active {
                    border: 1px solid ${props => props.theme?.products?.grid?.color?.border_color_active ?? '#000'};
                }
                &.exhausted-color {
                    pointer-events: none;
                    position: relative;
                    border: 1px solid red;
                    &:after {
                        content: '';
                        position: absolute;
                        top: 0px;
                        left: 10px;
                        width: 1px;
                        height: 20px;
                        background-color: red;
                        z-index: 9;
                        transform: rotate(-45deg);
                    }
                }
            }
        }
        .banner-meta {
            display: flex;
            align-items: center;
            flex-direction: row;
            border-bottom: .1rem solid ${props => props.theme?.border_color_site ?? '#dee2e6'};
            color: #858585;
            font: ${props => props.theme?.products?.font_weight ?? 400} ${props => props.theme?.products?.font_size ?? '1.5rem'} ${props => props.theme?.font_family ?? 'Open Sans'}, sans-serif;
            letter-spacing: .01rem;
            padding: 1.55rem 0;
            a {
                color: ${props => props.theme?.products?.title_color ?? '#2b2b2d'};
                text-transform: ${props => props.theme?.products?.text_transform ?? 'uppercase'};
                letter-spacing: .02rem;
                white-space: ${props => props.theme?.products?.white_space ?? 'nowrap'};
                overflow: hidden;
                text-overflow: ellipsis;
                ${props => props.theme?.products?.white_space == 'normal' ? 'display: -webkit-box;' : ''}
                ${props => props.theme?.products?.white_space == 'normal' ? '-webkit-box-orient: vertical;' : ''}
                -webkit-line-clamp: ${props => props.theme?.products?.max_lines_title ?? 10};
                &:hover,
                &:focus {
                    color: ${props => props.theme?.products?.title_color_hover ?? '#000'};
                    text-decoration: none;
                }
            }
            .banner-price {
                margin-left: auto;
                font-family: ${props => props.theme?.font_family ?? 'Open Sans'}, sans-serif;
                color: ${props => props.theme?.products?.price_color ?? '#595959'};
                font-weight: ${props => props.theme?.products?.font_weight_price ?? 600};
                font-size: 1.7rem;
                padding-left: 1rem;
                display: flex;
                flex-direction: column;
                .old-banner-price {
                    text-decoration: line-through;
                }
                .old-banner-price,
                .from-price {
                    font-size: 1.4rem;
                    text-align: right;
                    color: ${props => props.theme?.text_site_color ?? '#4a505e'};
                }
                &.unavailable {
                    color: ${props => props.theme?.products?.product_unavailable?.color ?? '#777'};
                    font-weight: ${props => props.theme?.products?.product_unavailable?.font_weight ?? '400'};
                    font-size: ${props => props.theme?.products?.product_unavailable?.font_size ?? '1.3rem'};
                    text-transform: ${props => props.theme?.products?.product_unavailable?.text_transform ?? 'lowercase'};
                    text-align: right;
                    strong {
                        color: ${props => props.theme?.products?.product_unavailable?.unavailable_color ?? '#ff6347'};
                    }
                }
            }
        }
    }

    .col-sm-4.item {
        position: relative;
        &:before {
            content: '+';
            position: absolute;
            left: -6px;
            top: 50%;
            font-size: 20px;
            color: ${props => props.theme?.text_site_color ?? '#4a505e'};
        }
    }

    .item-tie-sale {
        position: relative;
        /* box-shadow: 0 0 35px rgba(0, 0, 0, 0.05); */
        border-radius: 7px;
        cursor: pointer;
        /* &:before {
            content: '+';
            position: absolute;
            left: -20px;
            top: 50%;
            font-size: 20px;
            color: ${props => props.theme?.text_site_color ?? '#4a505e'};
        } */
        .check-item {
            position: absolute;
            top: -15px;
            right: -15px;
            height: 35px;
            width: 35px;
            background: #fff;
            border-radius: 50%;
            box-shadow: 0 12px 35px rgba(0, 0, 0, 0.15);
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            i {
                font-size: 1.6rem;
                color: ${props => props.theme?.primary_color};
            }
        }
    }

    .actions-tie-sale {
        > span {
            display: block;
            margin-bottom: 1rem;
            color: ${props => props.theme?.text_site_color ?? '#4a505e'};
            font: 400 1.5rem/1.1 ${props => props.theme?.font_family ?? 'Open Sans'}, sans-serif;
            big {
                font-size: 1.8rem;
                color: ${props => props.theme?.products?.product_page?.price_color ?? '#595959'};
            }
        }
        button {
            span {
                line-height: normal;
            }
        }
    }

    @media (max-width: 575px) {
        .col-sm-4 {
            max-width: 300px;
            margin: 0 auto;
            &.item {
                &:before {
                    left: 50%;
                    top: 0px;
                }
            }
        }
        .item-tie-sale {
            margin-top: 3rem;
            .check-item {
                top: 0px;
                right: 0px;
            }
        }
    }

`

export const CRatingContainer = styled.div`
    line-height: 1;
    margin: 0 0 10px 1px;
    cursor: pointer;
    position: relative;
    display: inline-block;

    &.align-rating-left {
        text-align: left;
    }

    &.align-rating {
        text-align: ${props => props.theme?.products?.content_alignment ?? 'center'};
    }

    > div {
        position: relative;
        display: inline-block;
        font-size: 13px;
        letter-spacing: 0.1em;
        font-family: 'porto';
        height: 13px;
        &:before {
            content: '\\e852 \\e852 \\e852 \\e852 \\e852';
            color: ${props => props.theme?.products?.rating?.star_color ?? '#00000029'};
        }
    }
    > a.rating-link {
        color: ${props => props.theme?.products?.rating?.label_color ?? '#777'};
    }
`

const propsCRating = {
    ratings: {
        default: '\\e852',
        type: String
    }
}
export const CRating = styled('span', propsCRating)`
    width:100%;
    position: absolute;
    top: 0;
    left: 0;
    white-space: nowrap;
    overflow: hidden;
    &:before {
        color: ${props => props.theme?.products?.rating?.star_color_active ?? '#ffcc03'};
        content: '${props => props.ratings}';
        float: left;
    }
`

export const CProductPriceBox = styled.div`
    min-height: ${props => props.theme?.products?.min_height_box_price ?? '0px'};
    &.align-price-box {
        text-align: ${props => props.theme?.products?.content_alignment ?? 'center'};
    }

    &.align-price-box-left {
        text-align: start;
    }

    span.from-price,
    span.old-price {
        color: ${props => props.theme?.products?.old_price_color ?? '#999'};
        font-size: ${props => props.theme?.products?.old_price_font_size ?? '1.4rem'};
        font-weight: ${props => props.theme?.products?.old_price_font_weight ?? '600'};
    }

    span.product-label {
        padding: 0;
        color: ${props => props.theme?.products?.free_shipping?.color ?? '#223ace'};
        text-transform: ${props => props.theme?.products?.free_shipping?.text_transform ?? 'uppercase'};
        font-family: ${props => props.theme?.font_family ?? 'Open Sans'}, sans-serif;
        font-weight: ${props => props.theme?.products?.free_shipping?.font_weight ?? '600'};
        font-size: ${props => props.theme?.products?.free_shipping?.font_size ?? '1rem'};
    }

    span.product-unavailable {
        color: ${props => props.theme?.products?.product_unavailable?.color ?? '#777'};
        font-weight: ${props => props.theme?.products?.product_unavailable?.font_weight ?? '400'};
        font-size: ${props => props.theme?.products?.product_unavailable?.font_size ?? '1.3rem'};
        text-transform: ${props => props.theme?.products?.product_unavailable?.text_transform ?? 'lowercase'};

        strong {
            color: ${props => props.theme?.products?.product_unavailable?.unavailable_color ?? '#ff6347'};
        }
    }

    span.text-variation {
        line-height: 1.5rem;
        padding-top: 1.5rem;
    }
`

export const CProductTitle = styled.h1`
    font-family: ${props => props.theme?.font_family ?? 'Open Sans'}, sans-serif;
    margin-bottom: .5rem;
    color: ${props => props.theme?.products?.product_page?.color_title ?? '#21293c'};
    font-size: ${props => props.theme?.products?.product_page?.font_size_title ?? '3.2rem'};
    font-weight: ${props => props.theme?.products?.product_page?.font_weight_title ?? 700};
    text-transform: ${props => props.theme?.products?.product_page?.text_transform_title ?? 'uppercase'};
    letter-spacing: -.01em;
    > a {
        font-family: ${props => props.theme?.font_family ?? 'Open Sans'}, sans-serif;
        color: ${props => props.theme?.products?.product_page?.color_title ?? '#21293c'};
        font-size: ${props => props.theme?.products?.product_page?.font_size_title ?? '3.2rem'};
        font-weight: ${props => props.theme?.products?.product_page?.font_weight_title ?? 700};
        text-transform: ${props => props.theme?.products?.product_page?.text_transform_title ?? 'uppercase'};
        letter-spacing: -.01em;
    }
`;

export const CProductTitleDefault = styled.h2`
    font: ${props => props.theme?.products?.font_weight ?? 400} ${props => props.theme?.products?.font_size ?? '1.5rem'} ${props => props.theme?.font_family ?? 'Open Sans'}, sans-serif !important;
    text-transform: ${props => props.theme?.products?.text_transform ?? 'uppercase'};
    color: ${props => props.theme?.products?.title_color ?? '#777'};
    min-height: ${props => props.theme?.products?.min_height_title ?? '0px'};

    &.align-title {
        text-align: ${props => props.theme?.products?.content_alignment ?? 'center'};
    }

    &.align-title-list {
        text-align: left;
    }

    > a {
        white-space: ${props => props.theme?.products?.white_space ?? 'nowrap'};
        color: ${props => props.theme?.products?.title_color ?? '#777'};
        text-transform: ${props => props.theme?.products?.text_transform ?? 'uppercase'};
        overflow: hidden;
        text-overflow: ellipsis;
        ${props => props.theme?.products?.white_space == 'normal' ? 'display: -webkit-box;' : ''}
        ${props => props.theme?.products?.white_space == 'normal' ? '-webkit-box-orient: vertical;' : ''}
        -webkit-line-clamp: ${props => props.theme?.products?.max_lines_title ?? 10};

        &:hover {
            color: ${props => props.theme?.products?.title_color_hover ?? '#000'};
        }
    }
    &:hover {
        color: ${props => props.theme?.products?.title_color_hover ?? '#000'};
    }
`;

export const CSidebarWrapper = styled.div`
    background-color: ${props => props.theme?.filters_categories?.background_color ?? props.theme?.background_color_site ?? '#fff'};

    .widget-body.scroll-filter {
      scrollbar-width: thin;
      scrollbar-color: ${props => props.theme?.filters_categories?.scroll?.color ?? '#ececec'} ${props => props.theme?.filters_categories?.scroll?.background_color ?? '#f9f9f9'};
    }

    .widget-body.scroll-filter::-webkit-scrollbar {
      width: 5px;
    }
    .widget-body.scroll-filter::-webkit-scrollbar-track {
      background: ${props => props.theme?.filters_categories?.scroll?.background_color ?? '#f9f9f9'};
    }
    .widget-body.scroll-filter::-webkit-scrollbar-thumb {
      background-color: ${props => props.theme?.filters_categories?.scroll?.color ?? '#ececec'};
      border-radius: 20px;
    }

    .widget {
        border: 1px solid ${props => props.theme?.filters_categories?.border_color ?? '#efefef'};
        border-bottom: 0;
        &:last-child {
            border-bottom: 1px solid ${props => props.theme?.filters_categories?.border_color ?? '#efefef'};
        }
        ul {
            margin-bottom: 0;
            li {
                a, span, label {
                    color: ${props => props.theme?.filters_categories?.color ?? '#4a505e'};
                    font-size: ${props => props.theme?.filters_categories?.font_size ?? '1.35rem'};
                    font-weight: ${props => props.theme?.filters_categories?.font_weight ?? '400'};
                }
            }
        }
        ul.config-swatch-list {
            li {
                display: inline;
                margin-bottom: .5rem;
                border: 1.8px solid ${props => props.theme?.filters_categories?.colors?.border_color ?? '#dae2e6'};
                border-radius: 50%;
                &.active {
                    border-color: ${props => props.theme?.filters_categories?.colors?.border_color_active ?? '#000'};
                    label::before {
                        color: ${props => props.theme?.filters_categories?.colors?.border_color_active ?? '#fff'};
                    }
                }
            }
        }
        ul.config-size-list {
            li {
                label {
                    color: ${props => props.theme?.filters_categories?.sizes?.color ?? '#4a505e'};
                    border-color: ${props => props.theme?.filters_categories?.sizes?.border_color ?? '#dadada'};
                    background-color: ${props => props.theme?.filters_categories?.sizes?.background_color ?? 'transparent'};
                    padding: 0 7px;
                }
                &.active label {
                    color: ${props => props.theme?.filters_categories?.sizes?.color_active ?? '#4a505e'};
                    border-color: ${props => props.theme?.filters_categories?.sizes?.border_color_active ?? '#000'};
                    background-color: ${props => props.theme?.filters_categories?.sizes?.background_color_active ?? 'transparent'};
                }
            }
        }
    }
`;

export const CWidgetFilter = styled.h3`
    font-family: ${props => props.theme?.filters_categories?.titles?.font_family ?? props.theme?.font_family ?? 'Open Sans'}, sans-serif !important;
    font-weight: ${props => props.theme?.filters_categories?.titles?.font_weight ?? '600'} !important;
    font-size: ${props => props.theme?.filters_categories?.titles?.font_size ?? '1.5rem'} !important;
    text-transform: ${props => props.theme?.filters_categories?.titles?.text_transform ?? 'uppercase'} !important;
    color: ${props => props.theme?.filters_categories?.titles?.color ?? '#2b2b2d'} !important;

    > a:hover,
    > a:focus {
        color: ${props => props.theme?.filters_categories?.titles?.color ?? '#2b2b2d'} !important;
    }
`;

export const CProductPrice = styled.span`
    font-family: ${props => props.theme?.font_family ?? 'Open Sans'}, sans-serif !important;
    color: ${props => props.theme?.products?.price_color ?? '#595959'} !important;
    font-weight: ${props => props.theme?.products?.font_weight_price ?? 600};
    font-size: ${props => props.theme?.products?.font_size_price ?? '1.8rem'};
`;

export const CProductPricePage = styled.span`
    font-family: ${props => props.theme?.font_family ?? 'Open Sans'}, sans-serif !important;
    color: ${props => props.theme?.products?.product_page?.price_color ?? '#595959'} !important;
    font-weight: ${props => props.theme?.products?.product_page?.font_weight_price ?? 700} !important;
`;

export const CStatusProduct = styled.div`
    display: grid;
    position: absolute;
    top: ${props => props.theme?.products?.status?.position?.top ?? '5%'};
    right: ${props => props.theme?.products?.status?.position?.right ?? null};
    bottom: ${props => props.theme?.products?.status?.position?.bottom ?? null};
    left: ${props => props.theme?.products?.status?.position?.left ?? 0};
`;

export const CProductStatusNew = styled.span`
    margin-bottom: 5px;
    text-align: center;
    left: 0;
    font-size: ${props => props.theme?.products?.status?.font_size ?? '1rem'} !important;
    font-weight: ${props => props.theme?.products?.status?.font_weight ?? 600} !important;
    text-transform: ${props => props.theme?.products?.status?.text_transform ?? 'uppercase'} !important;
    color: ${props => props.theme?.products?.status?.color_new ?? '#fff'} !important;
    border-radius: ${props => props.theme?.products?.status?.border_radius ?? '0 10px 10px 0'};
    background-color: ${props => props.theme?.products?.status?.background_color_new ?? '#7B68EE'};
    font-family: ${props => props.theme?.font_family ?? 'Open Sans'}, sans-serif !important;
    padding: ${props => props.theme?.products?.status?.padding ?? '5px 11px'} !important;
`;

export const CProductStatusSale = styled.span`
    margin-bottom: 5px;
    text-align: center;
    left: 0;
    font-size: ${props => props.theme?.products?.status?.font_size ?? '1rem'} !important;
    font-weight: ${props => props.theme?.products?.status?.font_weight ?? 600} !important;
    text-transform: ${props => props.theme?.products?.status?.text_transform ?? 'uppercase'} !important;
    color: ${props => props.theme?.products?.status?.color_sale ?? '#fff'} !important;
    border-radius: ${props => props.theme?.products?.status?.border_radius ?? '0 10px 10px 0'};
    background-color: ${props => props.theme?.products?.status?.background_color_sale ?? '#dd2828'};
    font-family: ${props => props.theme?.font_family ?? 'Open Sans'}, sans-serif !important;
    padding: ${props => props.theme?.products?.status?.padding ?? '5px 11px'} !important;
`;

export const CProductStatusDiscount = styled.span`
    margin-bottom: 5px;
    text-align: center;
    left: 0;
    font-size: ${props => props.theme?.products?.status?.font_size ?? '1rem'} !important;
    font-weight: ${props => props.theme?.products?.status?.font_weight ?? 600} !important;
    text-transform: ${props => props.theme?.products?.status?.text_transform ?? 'uppercase'} !important;
    color: ${props => props.theme?.products?.status?.color_discount ?? '#fff'} !important;
    border-radius: ${props => props.theme?.products?.status?.border_radius ?? '0 10px 10px 0'};
    background-color: ${props => props.theme?.products?.status?.background_color_discount ?? '#0f0'};
    font-family: ${props => props.theme?.font_family ?? 'Open Sans'}, sans-serif !important;
    padding: ${props => props.theme?.products?.status?.padding ?? '5px 11px'} !important;
`;

export const CProductWidth = styled.div`
    max-width: ${props => props.theme?.products?.product_page?.maxwidth_image ?? '350px'} !important;
`;

export const CInstallmentPrice = styled.span`
    color: ${props => props.theme?.products?.description_installment_color ?? '#878787'};
    font-weight: ${props => props.theme?.products?.description_installment_font_weight ?? 900};
    font-size: ${props => props.theme?.products?.description_installment_font_size ?? '11px'};
    margin-top: .72rem;
    text-align: ${props => props.theme?.products?.content_alignment ?? 'center'};
`;

export const CDiscountPix = styled.div`
    color: ${props => props.theme?.products?.description_installment_color ?? '#878787'};
    font-size: 15px;
    margin-top: 1rem;

    b {
        color: ${props => props.theme?.products?.discount_pix_color ?? '#878787'};
    }
`;

export const CProductAction = styled.div`
    &.align-actions-left {
        justify-content: start !important;
    }

    &.align-actions {
        justify-content: ${props => props.theme?.products?.content_alignment ?? 'center'} !important;
    }
`

// LINKED PRODUCTS ***
export const CLinkedProductsEndPage = styled.div`
    border: 1px solid ${props => props.theme?.products?.product_page?.variations?.border_color ?? '#dee2e6'};
    /* width: 230px; */
    height: 100px;
    display: flex;
    flex-direction: row;
    overflow: hidden;
    position: relative;
    transition: all .2s linear;
    border-radius: ${props => props.theme?.products?.product_page?.variations?.border_radius ?? '0'};
    background: ${props => props.theme?.products?.product_page?.variations?.background_color ?? 'transparent'};
    &.esgotado {
        pointer-events: none;
        z-index: 998;
        /* opacity: 0.8; */
    }
    &:hover {
        cursor: pointer;
        background: ${props => props.theme?.products?.product_page?.variations?.background_color_active ?? 'transparent'};
        border: 1px solid ${props => props.theme?.products?.product_page?.variations?.border_color_active ?? '#000'};
        > .content-linked-product-end-page {
            h2 {
                color: ${props => props.theme?.products?.product_page?.variations?.color_active ?? props.theme?.products?.product_page?.color_title ?? '#21293c'};
            }
            select {
                border-color: ${props => props.theme?.products?.product_page?.variations?.border_color_active ?? '#000'};
                color: ${props => props.theme?.products?.product_page?.variations?.color_active ?? props.theme?.products?.product_page?.color_title ?? '#21293c'} !important;
                &::placeholder {
                    color: ${props => props.theme?.products?.product_page?.variations?.color_active ?? props.theme?.products?.product_page?.color_title ?? '#21293c'} !important;
                }
                &:focus {
                    border-color: ${props => props.theme?.products?.product_page?.variations?.border_color_active ?? '#000'};
                }
            }
        }
    }
    &.active {
        background: ${props => props.theme?.products?.product_page?.variations?.background_color_active ?? 'transparent'};
        border: 1px solid ${props => props.theme?.products?.product_page?.variations?.border_color_active ?? '#000'};
        > .img-linked-product-end-page::before {
            content: '\f00c';
            display: inline-block;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translateX(-50%) translateY(-50%);
            color: ${props => props.theme?.products?.product_page?.variations?.icon_active_color ?? '#fff'};
            font-weight: 900;
            font-family: 'Font Awesome 5 Free';
            font-size: 5rem;
            line-height: 1;
            z-index: 999;
            padding: 1rem;
            border: 3px solid ${props => props.theme?.products?.product_page?.variations?.icon_active_color ?? '#fff'};
        }

        > .content-linked-product-end-page {
            h2 {
                color: ${props => props.theme?.products?.product_page?.variations?.color_active ?? props.theme?.products?.product_page?.color_title ?? '#21293c'};
            }
            select {
                border-color: ${props => props.theme?.products?.product_page?.variations?.border_color_active ?? '#000'};
                color: ${props => props.theme?.products?.product_page?.variations?.color_active ?? props.theme?.products?.product_page?.color_title ?? '#21293c'} !important;
                &::placeholder {
                    color: ${props => props.theme?.products?.product_page?.variations?.color_active ?? props.theme?.products?.product_page?.color_title ?? '#21293c'} !important;
                }
                &:focus {
                    border-color: ${props => props.theme?.products?.product_page?.variations?.border_color_active ?? '#000'};
                }
            }
        }
    }
    > .img-linked-product-end-page {
        width: 100px;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        > img {
            width: 100%;

            &[alt] {
                color: ${props => props.theme?.text_site_color ?? '#4a505e'};
            }
        }
    }
    > .content-linked-product-end-page {
        width: calc(100% - 100px);
        padding: 10px 10px 10px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        > h2 {
            font-size: 14px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-family: ${props => props.theme?.font_family ?? 'Open Sans'}, sans-serif;
            color: ${props => props.theme?.products?.product_page?.variations?.color ?? props.theme?.products?.product_page?.color_title ?? '#21293c'};
            font-weight: 500;
            text-transform: ${props => props.theme?.products?.product_page?.text_transform_title ?? 'uppercase'};
            margin-bottom: 4px;
            line-height: 1.4;
        }
        > select {
            margin: 0;
            padding: .2rem .5rem;
            height: auto;
            border: none;
            border-bottom: 1px solid ${props => props.theme?.products?.product_page?.variations?.border_color ?? '#dee2e6'};//${props => props.theme?.inputs?.border_color ?? '#e6e6e6'};
            background-color: transparent;
            color: ${props => props.theme?.inputs?.color ?? '#4a505e'} !important;
            outline: none;

            &::placeholder {
                color: ${props => props.theme?.inputs?.color ?? '#4a505e'} !important;
            }

            &:focus {
                background-color: transparent;
                border-color: ${props => props.theme?.inputs?.border_color ?? '#e6e6e6'};
            }
        }
        > span {
            font-size: 15px;
            font-family: ${props => props.theme?.font_family ?? 'Open Sans'}, sans-serif;
            color: ${props => props.theme?.products?.product_page?.price_color ?? '#595959'};
            font-weight: ${props => props.theme?.products?.product_page?.font_weight_price ?? 700};
        }
    }

    .link-tell-me-when-arrive {
        font-size: 1.2rem;
        font-family: ${props => props.theme?.font_family ?? 'Open Sans'}, sans-serif;
        color: ${props => props.theme?.products?.product_page?.price_color ?? '#595959'};
        font-weight: ${props => props.theme?.products?.product_page?.font_weight_price ?? 700};
    }
`;

export const CGridSize = styled.div`
    display: inline-block;
    margin-top: 3px;
    margin-bottom: 0;

    li {
        transition: all .2s linear;
        padding: 4px 10px;
        border: 1px solid ${props => props.theme?.products?.grid?.size?.border_color ?? '#dfdfdf'};
        background: ${props => props.theme?.products?.grid?.size?.background_color ?? '#fff'};
        margin-right: 3px;
        cursor: pointer;
        border-radius: ${props => props.theme?.products?.grid?.size?.border_radius ?? '0'};

        /* a { */
            span {
                color: ${props => props.theme?.products?.grid?.size?.color ?? '#000'};
                transition: all .2s linear;
            }
        /* } */

        &.active-size,
        &:hover {
            border: 1px solid ${props => props.theme?.products?.grid?.size?.border_color_active ?? '#000'};
            background: ${props => props.theme?.products?.grid?.size?.background_color_active ?? '#fff'};

            /* a { */
                span {
                    color: ${props => props.theme?.products?.grid?.size?.color_active ?? '#000'};
                }
            /* } */
        }

        &.active-size {
            pointer-events: none;
        }

        &.disabled-item {
            opacity: 0.7;
            pointer-events: none;
            border: 1px solid red;
        }
    }
`

export const CGridColor = styled.ul`
    li.colors.active {
        border: 1px solid ${props => props.theme?.products?.grid?.color?.border_color_active ?? '#000'};
        pointer-events: none;
    }

    li.colors {
        border: 1px solid transparent;
        &:hover {
            border: 1px solid ${props => props.theme?.products?.grid?.color?.border_color_active ?? '#000'};
        }
        span:hover {
            box-shadow: none;
        }
    }
`

export const CGridItems = styled.div`
    display: inline-block;
    margin-top: 3px;
    margin-bottom: 0;

    ul {
        display: flex;
        flex-wrap: wrap;
        margin-bottom: 0;

        li {
            transition: all .2s linear;
            padding: 4px 10px;
            border: 1px solid ${props => props.theme?.products?.grid?.size?.border_color ?? '#dfdfdf'};
            background: ${props => props.theme?.products?.grid?.size?.background_color ?? '#fff'};
            margin-right: 3px;
            margin-bottom: 0.3rem;
            cursor: pointer;
            border-radius: ${props => props.theme?.products?.grid?.size?.border_radius ?? '0'};

            span {
                color: ${props => props.theme?.products?.grid?.size?.color ?? '#000'};
                transition: all .2s linear;
            }

            &.active,
            &:hover {
                border: 1px solid ${props => props.theme?.products?.grid?.size?.border_color_active ?? '#000'};
                background: ${props => props.theme?.products?.grid?.size?.background_color_active ?? '#fff'};

                span {
                    color: ${props => props.theme?.products?.grid?.size?.color_active ?? '#000'};
                }
            }

            &.active {
                pointer-events: none;
            }

            &.disabled-grid {
                opacity: 0.7;
                pointer-events: none;
                border: 1px solid red;
            }
        }
    }
`

export const StyleProductDefault = styled.div`
    &.product-hover-shadow {
        transition: box-shadow 0.2s;
        padding-block: 1rem;
        border-radius: 0.25rem;
        border: 1px solid transparent;

        &:hover {
            border-color: ${props => props.theme?.products?.box_shadow_hover?.color ?? '#dfdfdf'};
            box-shadow: ${props => props.theme?.products?.box_shadow_hover?.content ?? '1px 1px 8px'} ${props => props.theme?.products?.box_shadow_hover?.color ?? '#dfdfdf'};
        }
    }
`;
